import type { SourceFormSource, SourceResource } from "@prequel/import-react";

const SERVER_MANAGED_FIELDS = ["id", "created_at", "updated_at"] as const;
const INTERNAL_VENDOR_FIELDS = ["is_valid"] as const;

/** Reshapes a saved source into the draft the form endpoint expects. */
export const sourceFormValues = (source: SourceResource): SourceFormSource => {
  const values = { ...source } as SourceFormSource & Record<string, unknown>;
  for (const field of SERVER_MANAGED_FIELDS) {
    delete values[field];
  }

  const branch = values[source.vendor];
  if (branch && typeof branch === "object" && !Array.isArray(branch)) {
    const branchValues = { ...(branch as Record<string, unknown>) };
    for (const field of INTERNAL_VENDOR_FIELDS) {
      delete branchValues[field];
    }
    values[source.vendor] = branchValues;
  }

  return values;
};
